/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { getUniqueDomId } from 'utils/getUniqueDomId';
  import Input              from 'components/g3w-input';

  const __vue_script__ = {

    /** @since 3.8.6 */
    name: 'input-lonlat',

    mixins: [Input],
    data() {
      return {
        lonId: getUniqueDomId(),
        latId: getUniqueDomId(),
        coordinatebutton: {
          active: false
        }
      }
    },
    computed:{
      getCoordinateActive() {
        return this.service.state.getCoordinateActive;
      }
    },
    methods: {
      toggleGetCoordinate() {
        this.service.toggleGetCoordinate();
      },
      changeLonLat() {
        this.change();
        this.setValue();
      },
      setValue() {
        this.state.value = [[1*this.state.values.lon, 1*this.state.values.lat]]
      }
    },
    created() {
      this.state.values = this.state.values || {lon:0, lat:0};
      this.setValue();
      this.service.setCoordinateButtonReactiveObject(this.coordinatebutton);
    },
    destroyed() {
      this.service.clear();
    }
  };

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticStyle:{"display":"flex","justify-content":"flex-end","height":"35px","margin-right":"12px","margin-bottom":"5px"}},[_c('button',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip",value:('sdk.form.inputs.tooltips.lonlat'),expression:"'sdk.form.inputs.tooltips.lonlat'"}],staticClass:"action skin-color skin-border-color",class:_vm.g3wtemplate.font['crosshairs'],staticStyle:{"border-radius":"5px","font-weight":"bold","font-size":"20px","cursor":"pointer"},style:({border: _vm.coordinatebutton.active ? '2px solid' : 0}),attrs:{"data-placement":"left"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.toggleGetCoordinate.apply(null, arguments)}}})]),_vm._v(" "),_c('baseinput',{attrs:{"state":_vm.state}},[_c('label',{staticClass:"col-sm-4 control-label",attrs:{"slot":"label","for":_vm.lonId},slot:"label"},[_vm._v(_vm._s(_vm.state.labels.lon)+"\n      "),(_vm.state.validate && _vm.state.validate.required)?_c('span',[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('input',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.editable),expression:"!editable"},{name:"model",rawName:"v-model",value:(_vm.state.values.lon),expression:"state.values.lon"}],staticClass:"form-control",class:{'input-error-validation' : _vm.notvalid},staticStyle:{"width":"100%","margin-bottom":"5px"},attrs:{"id":_vm.lonId,"tabIndex":_vm.tabIndex,"type":"number","min":"-180","max":"180","placeholder":"Lon"},domProps:{"value":(_vm.state.values.lon)},on:{"change":_vm.changeLonLat,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.state.values, "lon", $event.target.value)}}})])]),_vm._v(" "),_c('baseinput',{attrs:{"state":_vm.state}},[_c('label',{staticClass:"col-sm-4 control-label",attrs:{"slot":"label","for":_vm.latId},slot:"label"},[_vm._v(_vm._s(_vm.state.labels.lat)+"\n      "),(_vm.state.validate && _vm.state.validate.required)?_c('span',[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('input',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.editable),expression:"!editable"},{name:"model",rawName:"v-model",value:(_vm.state.values.lat),expression:"state.values.lat"}],staticClass:"form-control",class:{'input-error-validation' : _vm.notvalid},staticStyle:{"width":"100%","margin-bottom":"5px"},attrs:{"id":_vm.latId,"tabIndex":_vm.tabIndex,"type":"number","min":"-90","max":"90","placeholder":"Lon"},domProps:{"value":(_vm.state.values.lat)},on:{"change":_vm.changeLonLat,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.state.values, "lat", $event.target.value)}}})])])],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "InputLonLat.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__